import { API_URLS } from "../../../Configs/apiUrls";
import axiosInstance from "../../../Configs/axios";

export const myWishListFn = (redBody) => {
  try {
    const response = axiosInstance.get(API_URLS.myWishList, redBody);
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};
